import React from "react";
import {
	makeStyles,
	Slide,
	Fab,
	List,
	ListItem,
	ListItemText,
	Collapse,
	Divider,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle, CircularProgress, Button, Typography,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import axios from "axios";
import {addToState, getState} from "../../../controllers/stateController";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		maxWidth: 360,
	},
	active: {
		"&:hover": {
			background: theme.palette.secondary.main,
		},
		backgroundColor: theme.palette.secondary.main,
	},
	nested: {
		paddingLeft: theme.spacing(4),
	},
	center: {
		display: "flex",
		justifyContent: "center",
		flexDirection: "column"
	},
	moreButton: {
		marginTop: theme.spacing(1)
	},
	help: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		color: "black",
	},
	helpText: {
		backgroundColor: theme.palette.secondary.main,
		padding: theme.spacing(1),
		textAlign: "center"
	},
}));

export default function ListSettings({ roomInfo }) {
	const classes = useStyles();
	//This useState is for opening and closing the list options
	const [open, setOpen] = React.useState(false);

	//this useState is use for all settings
	const [state, setstate] = React.useState(false);

	const [selectedItem, setSelectedItem] = React.useState(null);

	const [selectedPlaylist, setSelectedPlaylist] = React.useState(() => {
		return getState().selected_playlist === undefined
			? null
			: getState().selected_playlist.name
	});
	const [playlists, setPlaylists] = React.useState(null);
	const [nextPlaylist, setNextPlaylist] = React.useState(null);



	const getPlaylists = (more=false) => {
		if(more) {
			axios.get(nextPlaylist, {
				headers: {
					'Authorization': `Bearer ${getState().access_token}`,
					'Accept':'application/json',
					"Content-Type": "application/json"
				}
			}).then(r => {
				setNextPlaylist(r.data.next)
				setPlaylists(playlists.concat(r.data.items))
			}).catch(e => {
				console.log(e)
			})
		}
		else {
			axios.get('https://api.spotify.com/v1/me/playlists', {
				params: {
					offset: 0,
					limit: 10
				},
				headers: {
					'Authorization': `Bearer ${getState().access_token}`,
					'Accept':'application/json',
					"Content-Type": "application/json"
				}
			}).then(r => {
				setPlaylists(r.data.items)
				setNextPlaylist(r.data.next)
			}).catch(e => {
				console.log(e)
			})
		}
	}

	const handlePlaylistSelect = (playlist) => {
		addToState({selected_playlist: playlist})
		setSelectedPlaylist(playlist.name)
		setOpen(false)

		axios.post(global.API_URL + "/set-playlist", {
			"token": getState().apiToken,
			"playlistId": playlist.id
		}).catch(error => console.log(error));
	}

	//Set if states for Managing Users {****
	const handleOpen = (item=null) => {
		setstate(true);
		setSelectedItem(item)
	};

	const handleUnBan = (song) => {
		axios.post(global.API_URL + "/ban-song", {
			artists: song.artists,
			songId: song.spotify_id,
			title: song.title,
			unBan: true,
			token: getState().apiToken,
		}).catch(function (error) {
				console.log(error)
			})

		handleClose();
	}

	const handleKick = () => {
		axios.post(global.API_URL + "/kick-user", {
			userId: selectedItem.id,
			token: getState().apiToken
		}).catch(function (error) {
			console.log(error)
		});

		handleClose();
	};

	const handleClick = (event) => {
		if(event === "playlist" && !open.playlistOpen) {
			getPlaylists()
		}
		setOpen({ [event + "Open"]: !open[event + "Open"] });
	};

	const handleClose = () => {
		setstate(false);
	};

	return (
		<List>
			<ListItem
				button
				className={classes.active}
				onClick={() => handleClick("blacklist")}
			>
				<ListItemText primary="Blacklisted Songs" />
				{open.blacklistOpen ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={open.blacklistOpen} timeout="auto" unmountOnExit>
				<Typography variant={"body2"} className={classes.helpText}>
					Select a song to remove it from the blacklist.
				</Typography>
				<List component="div" disablePadding>
					{roomInfo.banned_songs.sort().map((text, index) => (
						<ListItem
							id="blacklist-song"
							button
							onClick={() => handleOpen(text)}
							key={text.spotify_id}
							className={classes.nested}
						>
							<ListItemText style={{ color: "#191616" }} primary={text.title} />
						</ListItem>
					))}
					<Dialog
						open={state}
						onClose={handleClose}
						TransitionComponent={Transition}
						keepMounted
						aria-labelledby="unblacklistSong"
						aria-describedby="unblacklist-song-description"
					>
						<DialogTitle id="popup-song-option">
							{"Unblacklist Song?"}
						</DialogTitle>
						<DialogContent id="unblacklistDescription">
							<DialogContentText>
								Removing a song from the blacklist will allow users to put it in
								the voting queue.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Fab
								id="remove"
								variant="extended"
								size="medium"
								label="remove"
								className={classes.fab}
								color="primary"
								onClick={(e) => handleUnBan(selectedItem)}
							>
								Remove
							</Fab>
						</DialogActions>
					</Dialog>
				</List>
			</Collapse>
			<Divider />
			<ListItem
				button
				className={classes.active}
				onClick={() => handleClick("users")}
			>
				<ListItemText primary={`${roomInfo.guests.length} - Manage Users`} />
				{open.usersOpen ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={open.usersOpen} timeout="auto" unmountOnExit>
				<Typography variant={"body2"} className={classes.helpText}>
					Select a user to kick from the session.
				</Typography>
				<List component="div" disablePadding>
					{roomInfo.guests
						.sort(function (a, b) {
							if (a.name === b.name) {
								return 0;
							}

							if (a.name > b.name) {
								return 1;
							}

							return -1;
						})
						.map((text, index) => (
							<ListItem
								id="manage-user"
								button
								onClick={() => handleOpen(text)}
								key={text.id}
								className={classes.nested}
							>
								<ListItemText
									style={{ color: "#191616" }}
									primary={text.name}
								/>
							</ListItem>
						))}
					<Dialog
						open={state}
						onClose={handleClose}
						TransitionComponent={Transition}
						keepMounted
						aria-labelledby="ban-user"
						aria-describedby="ban-user-description"
					>
						<DialogTitle id="alert-dialog-slide-title">
							{"Do you want to kick this user?"}
						</DialogTitle>
						<DialogContent>
							<DialogContentText id="Manage-user-description">
								Kicking this user will force them to leave the current session.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Fab
								id="kick"
								variant="extended"
								size="medium"
								aria-label="kick"
								className={classes.fab}
								color="primary"
								onClick={() => handleKick()}
							>
								Kick
							</Fab>
						</DialogActions>
					</Dialog>
				</List>
			</Collapse>
			<Divider />
			<ListItem
				button
				className={classes.active}
				onClick={() => handleClick("playlist")}
			>
				<ListItemText style={selectedPlaylist !== null ? {color: "rgba(29, 185, 84, 1)"} : null } primary={`${selectedPlaylist === null ? "Backup Playlist" : selectedPlaylist}`} />
				{open.playlistOpen ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={open.playlistOpen} timeout="auto" unmountOnExit>
				<div className={classes.center}>
					<Typography variant={"body2"} className={classes.helpText}>
						Select a backup playlist to be used if no songs are requested.
					</Typography>
					<List component="div" disablePadding>
						{ playlists === null
							? <CircularProgress size={30} />
							: playlists.map((playlist) => (
								<div key={playlist.id}>
									<ListItem
										button
										onClick={() => handlePlaylistSelect(playlist)}
										className={classes.nested}
									>
										<ListItemText style={{ color: "#191616" }} primary={playlist.name} />
									</ListItem>
									<Divider/>
								</div>
							))}
					</List>
					{nextPlaylist !== null
						? <Button className={classes.moreButton} color="secondary" onClick={() => getPlaylists(true)}>
							<b>MORE</b>
						</Button>
						: null
					}
				</div>
			</Collapse>
		</List>
	);
}
